var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Grid } from '@app/Components/Grid/Grid';
import { Column, FilterRow, HeaderFilter, Scrolling, SearchPanel } from 'devextreme-react/data-grid';
import DateTimeService from '../../../../Services/DateTimeService';
import { enumHelper } from '../../../../Helpers/EnumHelper';
import { FiUserCheck, FiUserX } from 'react-icons/fi';
export var ActivitiesTable = /** @class */ (function (_super) {
    __extends(ActivitiesTable, _super);
    function ActivitiesTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._calculateDescriptionCell = function (data) {
            switch (data.actionType) {
                case 'UserConnected':
                case 'UserDisconnected':
                    return '';
                default:
                    return data.description;
            }
        };
        return _this;
    }
    ActivitiesTable.prototype.render = function () {
        var data = this.props.data;
        return (React.createElement(Grid, { dataSource: data },
            React.createElement(Column, { dataField: "serverName", groupIndex: 0, caption: "Server Name", autoExpandGroup: true }),
            React.createElement(Column, { dataField: "timestampUtc", caption: "Timestamp UTC", calculateCellValue: function (data) {
                    return DateTimeService.toUiTimestamp(data.timestampUtc);
                }, allowHeaderFiltering: false, width: 200 }),
            React.createElement(Column, { dataField: "userName", caption: "User", width: 240 }),
            React.createElement(Column, { dataField: "isUserOnline", caption: "Is Online", width: 110, allowSearch: false, allowFiltering: false, allowHeaderFiltering: true, cellRender: function (_a) {
                    var data = _a.data;
                    return data.isUserOnline ? React.createElement(FiUserCheck, { color: "green" }) : React.createElement(FiUserX, { color: "gray" });
                } }),
            React.createElement(Column, { dataField: "actionType", caption: "Action", calculateCellValue: function (data) {
                    return enumHelper.StatisticsActionTypeLabels[data.actionType];
                }, width: 160 }),
            React.createElement(Column, { dataField: "description", caption: "Description", allowHeaderFiltering: false, calculateCellValue: this._calculateDescriptionCell }),
            React.createElement(Column, { dataField: "duration", caption: "Duration (ms)", allowHeaderFiltering: false, width: "120", dataType: "Number" }),
            React.createElement(HeaderFilter, { visible: true }),
            React.createElement(SearchPanel, { visible: true }),
            React.createElement(FilterRow, { visible: true }),
            React.createElement(Scrolling, { mode: "virtual" })));
    };
    ActivitiesTable = __decorate([
        observer
    ], ActivitiesTable);
    return ActivitiesTable;
}(React.PureComponent));
